<template>
  <v-app id="organizations" :style="background">
    <v-navigation-drawer
      v-model="drawer"
      :color="icon_color"
      width="238px"
      dark
      app
      clipped
    >
      <template v-slot:prepend>
        <div v-if="logoImage[0]">
          <div v-if="logoImage[0].logo_url != ''">
            <Menuheader
              :title="logoImage[0].name"
              :logo="logoImage[0].logo_url"
            />
          </div>
          <div v-else>
            <Menuheader :title="logoImage[0].name" />
          </div>
        </div>
      </template>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="(option, index) in options"
          :key="index"
          :to="option.path"
          @click.stop
        >
          <v-list-item-action>
            <v-icon>{{ option.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ option.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left dark :color="color" class="pl-7 pr-7">
      <v-app-bar-nav-icon
        elevation="0"
        @click.stop="drawer = !drawer"
        aria-label=" botón del menú izquierdo del administrador de la organización"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <h1 class="title">Administrador de la Organización</h1>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <Logoutcard :username="fullName" :photo="photo" />
    </v-app-bar>

    <v-main app>
      <router-view />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import Menuheader from '../../components/MenuHeader'
import Logoutcard from '../../components/LogoutCard'
import Footer from '../../components/Footer'

export default {
  components: {
    Menuheader,
    Logoutcard,
    Footer,
  },
  created() {
    this.manager = JSON.parse(localStorage.getItem('user'))
    this.$store.dispatch('organization/fetchOrganizations')
  },
  data() {
    return {
      manager: {},
      drawer: null,
      titleMenu: 'Organización',
      photo: '',
      options: [
        {
          title: 'Tutores',
          icon: 'mdi-human-male-male',
          path: { name: 'tutors' },
        },
        {
          title: 'Usuarios',
          icon: 'mdi-account',
          path: { name: 'players' },
        },
        {
          title: 'Habilidades',
          icon: 'mdi-lightbulb-on-outline',
          path: { name: 'abilities' },
        },
        {
          title: 'Periodo',
          icon: 'mdi-calendar-plus',
          path: { name: 'periods' },
        },
        {
          title: 'Plan de intervención',
          icon: 'mdi-file-document-edit-outline',
          path: { name: 'interventionplans' },
        },
        {
          title: 'Reporte general',
          icon: 'mdi-chart-line',
          path: { name: 'globalReport' },
        },
        {
          title: 'Cronograma diario',
          icon: 'mdi-calendar-month-outline',
          path: { name: 'dailyplans' },
        },
        {
          title: 'Personalizar Juegos',
          icon: 'mdi-google-controller',
          path: { name: 'gamecustomizer' },
        },
      ],
    }
  },
  computed: {
    background() {
      return {
        background: '#ABB2B9',
      }
    },
    ...mapState({
      color: (state) => state.layout.color,
      icon_color: (state) => state.layout.icon_color_bar,
      primary: (state) => state.layout.primary,
      organizations: (state) => state.organization.organizations,
    }),
    fullName() {
      return this.manager.full_name
    },
    logoImage() {
      return this.organizations.filter(
        (element) => element.id == this.$route.params.id
      )
    },
  },
}
</script>
